import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import { push } from 'connected-react-router';
import { updateBrandBrandingForm, fetchBrand } from 'services/brands/duck';
import EditBrandBrandingForm from 'components/organisms/forms/EditBrandBranding';
import BrandTabView from 'components/organisms/brand/BrandTabView';

class EditBrandBrandingContainer extends Component {
    componentDidMount() {
        const brandId = this.props.match.params.id;

        if (this.props.fetchBrand && brandId) {
            this.props.fetchBrand({ brandId });
        }
    }

    render() {
        return (
            <BrandTabView selected="branding" brand={this.props.brand} push={this.props.push}>
                <EditBrandBrandingForm
                    brand={this.props.brand || {}}
                    theme={this.props.theme}
                    dispatch={this.props.dispatch}
                    pristine={this.props.pristine}
                    handleSubmit={this.props.handleSubmit.bind(null, updateBrandBrandingForm)}
                    push={this.props.push}
                >
                </EditBrandBrandingForm>
            </BrandTabView>
        );
    }
}

const mapStateToProps = state => ({
    brand: state.brands.brand,
    initialValues: state.brands.brand
});

export default compose(
    connect(mapStateToProps, { fetchBrand, push }),
    reduxForm({
        form: 'editBrandBranding',
        enableReinitialize: true,
        fields: ['branding.removeLogo'],
    })
)(EditBrandBrandingContainer);



// WEBPACK FOOTER //
// ./src/containers/forms/brands/EditBrandBrandingContainer.js